import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoginForm } from 'src/app/core/models/login-form';
import { LoginResponse } from 'src/app/core/models/login-response';
import { AuthService } from 'src/app/core/services/auth.service';
import { FooterService } from 'src/app/core/services/footer.service';
import { LoadingIndicatorService } from 'src/app/core/services/loading-indicator.service';

@Component({
  selector: 'th-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: LoginForm = new LoginForm();
  submitting = false;
  isLoginVisible = true;

  constructor(
    private authService: AuthService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private loadingIndicatorService: LoadingIndicatorService,
    private footerService: FooterService,
    private location: Location
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.isLoginVisible = false;

      this.loadingIndicatorService.show();

      this.router
        .navigate(['/private'])
        .catch(() => (this.isLoginVisible = true))
        .finally(() => this.loadingIndicatorService.hide());
    }
  }

  onSubmit(ngForm: NgForm) {
    this.submitting = true;

    this.authService
      .authenticate(this.loginForm)
      .pipe(
        catchError(() => {
          ngForm.resetForm();

          // Need to manually trigger change detection to prevent console error here
          this.changeDetectorRef.detectChanges();

          return of(null);
        }),
        finalize(() => {
          this.submitting = false;
        })
      )
      .subscribe((response: LoginResponse) => {
        if (response) {
          // The login redirect is lazy loaded so we want to hide the login page while that happens
          this.isLoginVisible = false;

          this.loadingIndicatorService.show();

          const newUrl = this.authService.loginRedirect || '/private';

          if (response.appVersion === this.footerService.appVersion) {
            this.router
              .navigate([newUrl])
              .then((navigatedSuccessfully) => {
                if (navigatedSuccessfully) {
                  this.authService.loginRedirect = null;
                }
              })
              .catch(() => (this.isLoginVisible = true))
              .finally(() => this.loadingIndicatorService.hide());
          } else {
            // Force a full page reload to re-fetch newest JS files.
            // We have to use Location#prepareExternalUrl() to take our base href into account.
            window.location.href = this.location.prepareExternalUrl(newUrl);
          }
        }
      });
  }
}
